const { getElements } = window.BAO.Utils

class WishlistPage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.populateLists = this.populateLists.bind(this)
    this.handleWishlistChange = this.handleWishlistChange.bind(this)
    this.setupWishlist = this.setupWishlist.bind(this)

    this.handleRemoveItem = this.handleRemoveItem.bind(this)

    this.getCurrentWishlistDetails = this.getCurrentWishlistDetails.bind(this)

    this.wishlistError = this.wishlistError.bind(this)

    this.listeners.add(document, 'click', this.handleWishlistChange)
    this.listeners.add(document, 'click', this.handleRemoveItem)

    this.handleBack = this.handleBack.bind(this)
    this.els.back.elements.forEach((backEl) => {
      this.listeners.add(backEl, 'click', this.handleBack)
    })

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      if (window._swat) {
        window._swat.fetchLists({
          force: true,
          callbackFn: this.populateLists,
          errorFn: this.wishlistError,
        })
      }
    })
  }

  populateLists (lists) {
    this.els.delete.element.setAttribute('aria-hidden', lists.length < 2)

    this.els.wishlists.element.innerHTML = ''
    this.els.back.elements.forEach((backEl) => {
      backEl.setAttribute('aria-hidden', false)
    })

    if (lists.length === 1) {
      this.els['current-wishlist-text'].element.setAttribute(
        'data-wishlist-id',
        lists[0].lid,
      )

      this.getCurrentWishlistDetails()

      this.els.back.elements.forEach((backEl) => {
        backEl.setAttribute('aria-hidden', true)
      })
    } else if (lists.length > 0) {
      lists.forEach((list, index) => {
        if (index === 0) {
          this.els['current-wishlist-text'].element.setAttribute(
            'data-wishlist-id',
            list.lid,
          )
        }

        this.els.wishlists.element.innerHTML += this.createHomeElement(
          list,
          index,
        )
      })

      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', false)
      this.els['page-empty'].element.setAttribute('aria-hidden', true)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', true)
      this.els['page-empty'].element.setAttribute('aria-hidden', false)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    }
  }

  createHomeElement (list, index) {
    let cardImages = ''

    if (list.cnt > 0) {
      cardImages = '<div class="wsh-Card_Images">'
      list.listcontents.slice(0, 2).forEach((listItem) => {
        cardImages += `<div class="wsh-Card_ImageContainer"><img class="wsh-Card_Image" src="${listItem.iu}" alt="${listItem.dt}"></div>`
      })

      cardImages += '</div>'
    }

    return `<div class="wsh-Card">
      <button
        type="button"
        class="wsh-Card_Title fz-20_100"
        data-wishlist-page-el="wishlist-change-trigger"
        data-wishlist-id="${list.lid}"
      >
        ${list.lname}
      </button>
      <p class="wsh-Card_Text fz-14_120">${list.cnt} ${
        list.cnt === 1
          ? window.theme.wishlist.item
          : window.theme.wishlist.items
      }</p>

      ${cardImages}

      <div class="wsh-Card_Buttons">
      ${
        list.cnt === 0
          ? `<a href="/collections/all" class="wsh-Card_Button btn-Button btn-Button-primary btn-Button-dark btn-Button-fullWidth">
            ${window.theme.wishlist.addToWishlist}
            </a>`
          : `<button type="button" class="wsh-Card_Button btn-Button btn-Button-primary btn-Button-dark btn-Button-fullWidth" data-wishlist-page-el="wishlist-change-trigger" data-wishlist-id="${list.lid}">
            ${window.theme.wishlist.viewWishlist} 
          </button>`
      }
      </div>
    </div>`
  }

  handleWishlistChange (event) {
    const trigger = event.target.closest(
      '[data-wishlist-page-el="wishlist-change-trigger"]',
    )

    if (!trigger) return

    this.els['current-wishlist-text'].element.setAttribute(
      'data-wishlist-id',
      trigger.dataset.wishlistId,
    )

    this.getCurrentWishlistDetails()
  }

  getCurrentWishlistDetails () {
    const listConfig = {
      lid: this.els['current-wishlist-text'].element.dataset.wishlistId,
    }

    window._swat.fetchListDetails(
      listConfig,
      this.setupWishlist,
      this.wishlistError,
    )
  }

  async setupWishlist (wishlist) {
    this.els['current-wishlist-text'].elements.forEach((el) => {
      el.textContent = `${wishlist.list.lname} (${wishlist.list.cnt})`
    })

    if (this?.els?.share?.exists) {
      this.els.share.element.setAttribute(
        'data-wishlist-id',
        wishlist.list.lid,
      )
    }

    this.els.delete.elements.forEach((el) => {
      el.setAttribute('data-wishlist-id', wishlist.list.lid)
    })

    getElements('[data-wishlist-page-el="wishlist-change-trigger"]').forEach(
      (el) => {
        el.setAttribute(
          'aria-current',
          el.dataset.wishlistId === wishlist.list.lid,
        )
      },
    )

    const productCardHTML = await this.getAllProductCardHTML(wishlist)
    this.els.products.element.innerHTML = productCardHTML

    if (wishlist.list.cnt > 0) {
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['panel-empty'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['panel-empty'].element.setAttribute('aria-hidden', false)
    }

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-home'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', true)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', false)
  }

  async getAllProductCardHTML (wishlist) {
    const productCardHTML = await Promise.all(
      wishlist.items.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    const productUrl = product.du.replace(
      '/products/',
      `${window.Shopify.routes.root}products/`,
    )

    return window.BAO.sectionRenderer
      .fetchSingle(
        'wishlist-product-card',
        `${productUrl}?variant=${product.epi}`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.prd-Card')

        if (myself) {
          return `<div class="wsh-Page_Item">${myself.outerHTML.replace(
            'data-wishlist-page-el="remove"',
            `data-wishlist-page-el="remove" data-product-id="${product.empi}" data-variant-id="${product.epi}" data-product-url="${product.du}"`,
          )}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }

  handleRemoveItem (event) {
    const trigger = event.target.closest('[data-wishlist-page-el="remove"]')

    if (!trigger) return

    const lid = this.els['current-wishlist-text'].element.dataset.wishlistId

    const product = {
      epi: trigger.dataset.variantId,
      empi: trigger.dataset.productId,
      du: trigger.dataset.productUrl,
    }

    window._swat.deleteFromList(
      lid,
      product,
      this.getCurrentWishlistDetails,
      this.wishlistError,
    )
  }

  handleBack () {
    if (window._swat) {
      window._swat.fetchLists({
        force: true,
        callbackFn: this.populateLists,
        errorFn: this.wishlistError,
      })
    }
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-home'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', false)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('wishlist-page')) {
  customElements.define('wishlist-page', WishlistPage)
}
